import { IFinding, TValidatorSeverity } from "../types";

const RANK: Record<TValidatorSeverity, number> = { info: 1, warning: 2, error: 3 };

/**
 * The worst severity among the findings. A finding without its own severity counts as
 * `fallback`. `undefined` when there are no findings.
 */
export function worstSeverity(
  findings: IFinding[],
  fallback: TValidatorSeverity,
): TValidatorSeverity | undefined {
  let worst: TValidatorSeverity | undefined = undefined;

  for (const f of findings) {
    const sev = f.severity ?? fallback;
    if (worst === undefined || RANK[sev] > RANK[worst]) worst = sev;
    if (worst === "error") break;
  }

  return worst;
}

export function isWorseOrEqual(a: TValidatorSeverity, b: TValidatorSeverity): boolean {
  return RANK[a] >= RANK[b];
}
